// extracted by mini-css-extract-plugin
export default {"icon":"icon__ygX9i8","searchInput":"searchInput___uzpUx"};